<template>
  <div class="silder-contain slider-goalManage silder-contain-creat">
    <el-form ref="editForm" :model="editForm" :rules="rules" class="form-goal" label-width="180px">
      <div class="slider-top clearFloat">
        <p class="h3 slider-title pull-left">{{$t('Aims.title2')}}</p>
        <div class="pull-right h1 btn-close font-gray" @click="hideSliderBoxEdit">
          <i class="el-icon-close"></i>
        </div>
        <!-- <el-button type="primary" class="pull-right" @click="editSubmit(editForm)">完成</el-button> -->
        <el-form-item class="btn-submit pull-right">
          <el-button @click="editSubmit('editForm')" type="primary">{{$t('Common.btn_complete')}}</el-button>
        </el-form-item>
      </div>
      <div class="slider-cont text-1 slider-edit-cont">
        <p class="form-small-title h3">{{$t('Aims.s_title1')}}</p>
        <!-- <el-form ref="form" :model="form" :rules="rules" class="form-goal" label-width="130px"> -->
        <el-form-item :label="$t('Aims.label_text1')" prop="goal_name">
          <el-input
            v-model="editForm.goal_name"
            style="width: 365px;"
            :placeholder="$t('Aims.placeholder1')"
          ></el-input>
        </el-form-item>
        <div class="aims-time">
          <el-form-item :label="$t('Aims.label_text2')" prop="goal_starttime">
            <el-date-picker
              v-model="editForm.goal_starttime"
              @change="changeStart"
              style="width: 365px;"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('Aims.placeholder2')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Aims.label_text3')" prop="goal_endtime">
            <el-date-picker
              v-model="editForm.goal_endtime"
              :picker-options="pickerOptionsEnd"
              @change="changeEnd"
              style="width: 365px;"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('Aims.placeholder3')"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="row-number clearFloat">
          <el-form-item
            :label="$t('Aims.label_text4')"
            class="input-row tag-must pull-left"
            prop="goal_mintrack"
          >
            <el-input
              v-model="editForm.goal_mintrack"
              style="width: 170px;"
              :placeholder="$t('Aims.placeholder4_1')"
              @blur="checkInput1()"
            ></el-input>
            <div class="error-tip tip1" id="tip1" v-if="error1">{{errorTips[0]}}</div>
          </el-form-item>
          <el-form-item label class="input-row pull-left tag-must" prop="goal_normtrack">
            <el-input
              v-model="editForm.goal_normtrack"
              style="width: 170px;"
              :placeholder="$t('Aims.placeholder4_2')"
              @blur="checkInput2()"
            ></el-input>
            <div class="error-tip tip2" id="tip2" v-if="error2">{{errorTips[1]}}</div>
          </el-form-item>
        </div>
        <div class="row-number clearFloat">
          <el-form-item
            :label="$t('Aims.label_text5')"
            class="input-row pull-left tag-must"
            prop="goal_mininvite"
          >
            <el-input
              v-model="editForm.goal_mininvite"
              style="width: 170px;"
              :placeholder="$t('Aims.placeholder5_1')"
              @blur="checkInput3()"
            ></el-input>
            <div class="error-tip tip3" id="tip3" v-if="error3">{{errorTips[2]}}</div>
          </el-form-item>
          <el-form-item label class="input-row pull-left tag-must" prop="goal_norminvite">
            <el-input
              v-model="editForm.goal_norminvite"
              style="width: 170px;"
              :placeholder="$t('Aims.placeholder5_2')"
              @blur="checkInput4()"
            ></el-input>
            <div class="error-tip tip4" id="tip4" v-if="error4">{{errorTips[3]}}</div>
          </el-form-item>
        </div>
        <div class="row-number clearFloat">
          <el-form-item
            :label="$t('Aims.label_text6')"
            class="input-row tag-must pull-left"
            prop="goal_minofficial"
          >
            <el-input
              v-model="editForm.goal_minofficial"
              style="width: 170px;"
              :placeholder="$t('Aims.placeholder6_1')"
              @blur="checkInput5()"
            ></el-input>
            <div class="error-tip tip5" id="tip5" v-if="error5">{{errorTips[4]}}</div>
          </el-form-item>
          <el-form-item label class="input-row pull-left tag-must" prop="goal_normofficial">
            <el-input
              v-model="editForm.goal_normofficial"
              style="width: 170px;"
              :placeholder="$t('Aims.placeholder6_2')"
              @blur="checkInput6()"
            ></el-input>
            <div class="error-tip tip6" id="tip6" v-if="error6">{{errorTips[5]}}</div>
          </el-form-item>
        </div>
        <el-form-item :label="$t('Aims.label_text7')" prop="goal_maxtracknumber">
          <el-input
            v-model="editForm.goal_maxtracknumber"
            style="width: 365px;"
            :placeholder="$t('Aims.placeholder7')"
          ></el-input>
          <el-tooltip
            class="item"
            effect="dark"
            popper-class="hover-item-prop"
            :content="$t('Aims.tooltips_cont')"
            placement="bottom"
          >
            <em class="el-icon-question h1 ml10 font-blue" style></em>
          </el-tooltip>
        </el-form-item>
        <!-- </el-form> -->
        <p class="form-small-title h3">{{$t('Aims.s_title2')}}</p>
        <div class="setting">
          <p class="clearFloat setting-label">
            <span class="h-3">
              {{$t('Aims.label_text8')}}
              <span
                class="tab-check text-3"
              >{{$t('Aims.placeholder8')}}{{StaffEditNum}}{{$t('Aims.placeholder9')}}</span>
            </span>
          </p>
          <ul class="joinlist">
            <li v-for="(item,index) in settingStaff" :key="index">
              <input
                class="li-checkbox"
                @change="handClickstaffedit()"
                type="checkbox"
                :value="item.id"
                v-model.lazy="editForm.checkMarketer"
              />
              <label>
                {{item.name}}
                <i
                  :class="{'crmIcon-nv':item.sex==$t('Common.woman'),'crmIcon-nan':item.sex!=$t('Common.woman')}"
                ></i>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "aimsEdit",
  props: ["settingStaff", "basicinformation", "joinlist"],
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("Aims.rule_tips1")));
      } else {
        const reg = /^\+?[1-9][0-9]*$/;
        (() => {})(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error(this.$t("Aims.rule_tips1_2")));
        }
      }
    };
    return {
      StaffEditNum: 0,
      editForm: {
        goal_name: "",
        goal_starttime: "",
        goal_endtime: "",
        goal_mintrack: "",
        goal_normtrack: "",
        goal_norminvite: "",
        goal_mininvite: "",
        goal_normofficial: "",
        goal_minofficial: "",
        goal_maxtracknumber: "50",
        checkMarketer: []
      },
      // 表单验证
      rules: {
        goal_name: [
          {
            required: true,
            message: this.$t("Aims.rule_tips2"),
            trigger: "blur"
          },
          {
            min: 2,
            max: 30,
            message: this.$t("Aims.rule_tips3"),
            trigger: "blur"
          }
        ],
        goal_starttime: [
          {
            required: true,
            message: this.$t("Aims.rule_tips4"),
            trigger: "change"
          }
        ],
        goal_endtime: [
          {
            required: true,
            message: this.$t("Aims.rule_tips5"),
            trigger: "change"
          }
        ],
        goal_maxtracknumber: [
          {
            required: true,
            message: this.$t("Aims.rule_tips6"),
            trigger: "blur"
          }
        ],
        goal_mintrack: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        goal_normtrack: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        goal_norminvite: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        goal_mininvite: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        goal_normofficial: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        goal_minofficial: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ]
      },
      //限制开始时间
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.editForm.goal_endtime;
          let beginDateVal = this.editForm.goal_starttime;
          if (endDateVal) {
            return (
              time.getTime() <
                new Date(new Date().toLocaleDateString()).getTime() &&
              new Date(beginDateVal).getTime() < new Date(endDateVal).getTime()
            );
          } else {
            return (
              time.getTime() <
              new Date(new Date().toLocaleDateString()).getTime()
            );
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.editForm.goal_starttime;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      },
      error1: false,
      error2: false,
      error3: false,
      error4: false,
      error5: false,
      error6: false,
      errorTips: ["", "", "", "", "", ""]
    };
  },
  components: {},
  created() {
    //   this.editForm=this.basicinformation;
    this.editForm = {
      goal_name: this.basicinformation.goal_name,
      goal_starttime: this.basicinformation.goal_starttime,
      goal_endtime: this.basicinformation.goal_endtime,
      goal_mintrack: this.basicinformation.goal_mintrack,
      goal_normtrack: this.basicinformation.goal_normtrack,
      goal_maxtracknumber: this.basicinformation.goal_maxtracknumber,
      goal_norminvite: this.basicinformation.goal_norminvite,
      goal_mininvite: this.basicinformation.goal_mininvite,
      goal_normofficial: this.basicinformation.goal_normofficial,
      goal_minofficial: this.basicinformation.goal_minofficial,
      checkMarketer: this.basicinformation.participantid.split(",")
    };
    (() => {})(this.basicinformation);
    this.StaffEditNum = this.basicinformation.participantid.split(",").length;
  },
  computed: {},
  methods: {
    hideSliderBoxEdit() {
      this.$emit("hideSliderBoxEdit");
    },
    editSubmit(v) {
      this.$refs[v].validate(valid => {
        if (valid) {
          if (
            parseInt(this.editForm.goal_normtrack) >=
              parseInt(this.editForm.goal_mintrack) &&
            parseInt(this.editForm.goal_norminvite) >=
              parseInt(this.editForm.goal_mininvite) &&
            parseInt(this.editForm.goal_normofficial) >=
              parseInt(this.editForm.goal_minofficial)
          ) {
            this.$emit("editSubmit", this.editForm);
          } else {
            this.$message({
              message: "达标人次必须大于等于最少人次！",
              type: "error"
            });
          }
        } else {
          (() => {})("error submit!!");
          return false;
        }
      });
    },
    // 选择职工
    handClickstaffedit() {
      this.StaffEditNum = this.editForm.checkMarketer.length;
    },
    //结束时间限制开始时间
    changeStart() {
      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        // 可通过箭头函数的方式访问到this
        disabledDate: time => {
          var times = "";
          times =
            this.editForm.goal_starttime < time.getTime() ||
            time.getTime() <
              new Date(new Date().toLocaleDateString()).getTime();
          return times;
        }
      });
    },
    //开始时间 控制结束时间
    changeEnd() {
      // this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
      //     disabledDate: (time) => {
      //         return time.getTime() < this.editForm.goal_endtime
      //     }
      // })
    },
    // 表单验证
    checkInput1() {
      if (
        parseInt(this.editForm.goal_normtrack) <
          parseInt(this.editForm.goal_mintrack) &&
        this.editForm.goal_normtrack != ""
      ) {
        this.error1 = true;
        this.errorTips[0] = this.$t("Aims.rule_tips7");
      } else {
        this.error1 = false;
      }
    },
    checkInput2() {
      if (
        parseInt(this.editForm.goal_normtrack) <
          parseInt(this.editForm.goal_mintrack) &&
        this.editForm.goal_mintrack != ""
      ) {
        this.error2 = true;
        this.errorTips[1] = this.$t("Aims.rule_tips8");
      } else {
        this.error2 = false;
      }
    },
    checkInput3() {
      if (
        parseInt(this.editForm.goal_norminvite) <
          parseInt(this.editForm.goal_mininvite) &&
        this.editForm.goal_norminvite != ""
      ) {
        this.error3 = true;
        this.errorTips[2] = this.$t("Aims.rule_tips9");
      } else {
        this.error3 = false;
      }
    },
    checkInput4() {
      if (
        parseInt(this.editForm.goal_norminvite) <
          parseInt(this.editForm.goal_mininvite) &&
        this.editForm.goal_mininvite != ""
      ) {
        this.error4 = true;
        this.errorTips[3] = this.$t("Aims.rule_tips10");
      } else {
        this.error4 = false;
      }
    },
    checkInput5() {
      if (
        parseInt(this.editForm.goal_normofficial) <
          parseInt(this.editForm.goal_minofficial) &&
        this.editForm.goal_normofficial != ""
      ) {
        this.error5 = true;
        this.errorTips[4] = this.$t("Aims.rule_tips11");
      } else {
        this.error5 = false;
      }
    },
    checkInput6() {
      if (
        parseInt(this.editForm.goal_normofficial) <
          parseInt(this.editForm.goal_minofficial) &&
        this.editForm.goal_minofficial != ""
      ) {
        this.error6 = true;
        this.errorTips[5] = this.$t("Aims.rule_tips12");
      } else {
        this.error6 = false;
      }
    }
  }
};
</script>

<style lang="less">
.silder-contain .form-goal {
  // margin-bottom: 20px;
  padding: 0px 0px 0 0px;

  .slider-create-cont {
    padding: 20px 20px 0px 20px !important;
  }
}

.btn-submit {
  width: 60px;

  .el-form-item__content {
    margin-left: 0px !important;
  }
}

.row-number {
  .el-form-item + .el-form-item {
    .el-form-item__content {
      margin-left: 25px !important;
    }
  }
}

.row-number-last {
  margin-bottom: 20px;
}

.tag-must > label {
  font-family: "element-icons" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  // line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}

.tag-must > label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
  font-size: 12px;
}
</style>
